import { mapGetters, mapActions } from "vuex";

export default {
    name: "CopyToast",
    props: {
        bottom: {
            type: Number,
            default: 0
        }
    },
    computed: {
        ...mapGetters("ThesaurusFilter", ["getCopiedSynonym"]),
        toastPosition() {
            return this.bottom + 15; // 15 is a default bottom value of the toast
        }
    },
    methods: {
        ...mapActions("ThesaurusFilter", ["copySynonym"]),
        hide(e) {
            if (e.target.className !== "copy-button" || e.target.className !== "ydr-copy") {
                this.copySynonym();
            }
        }
    },
    created() {
        document.addEventListener("click", this.hide);
        document.addEventListener("scroll", this.hide);
    },
    destroyed() {
        document.removeEventListener("click", this.hide);
        document.removeEventListener("scroll", this.hide);
    }
};



// WEBPACK FOOTER //
// ./src/components/CopyToast/CopyToast.js